module.exports = __webpack_public_path__ + "static/self-80e1d7b0177399065a596ad063bea4f7.jpg";